import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mk6jmayu79: FaireBrandEntity = {
  token: "b_mk6jmayu79",
  type: "brand",
  name: "A Very Good Pasta Sauce",
  avatarUrl:
    "https://cdn.faire.com/fastly/a8f907fe975205b317977ae684623eb8313326beebdbf254de490a764b7e49ec.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/93112995ce35407fa5a3381283151b3ad6ea4611a79d0086c243f69a857cddc3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a8f907fe975205b317977ae684623eb8313326beebdbf254de490a764b7e49ec.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/93112995ce35407fa5a3381283151b3ad6ea4611a79d0086c243f69a857cddc3.jpeg",
  location: "North Vancoyver, BC, CAN",
  minimumOrderDollars: 150,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Smart N Local, established in 2020 and headquartered in North Vancouver, BC, began its journey by showcasing its culinary creations at local farmer's markets. Committed to using only the freshest ingredients sourced directly from local producers, our brand prides itself on crafting homemade pasta sauces without any additives. Our goal is simple yet ambitious: to provide our customers with the authentic taste of homemade pasta sauce, made with love and care, while supporting local farmers and promoting sustainability in our community.\n\nToday, Smart N Local's products can be found in numerous stores across BC. Our innovative packaging in convenient pouches preserves the freshness of our sauces without compromising on flavor. With each pouch, we aim to deliver not just a delicious sauce but also a piece of our dedication to quality, freshness, and culinary excellence. Join us in savoring the true essence of homemade pasta sauce, made the Smart N Local way.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:50.761Z",
    importedBy: "entity-db-cli",
  },
};
